import axios from 'axios'

const request = axios.create({
  baseURL: 'http://tarzan.minus.live/',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
    'Cache-Control': 'no-cache',
  },
});

export function getBannerData () {
  return request.get('/module/getData', {
    params: {
      name: 'banner',
      org_code: 'aec'
    }
  })
}

export function getCustomerData () {
  return request.get('/module/getData', {
    params: {
      name: 'customer',
      org_code: 'aec'
    }
  })
}

export function getSolutionData () {
  return request.get('/module/getData', {
    params: {
      name: 'solution',
      org_code: 'aec'
    }
  })
}

export function getCommentList () {
  return request.get('/comment/list', {
    params: {
      org_code: 'aec',
      page: 1,
      pageSize: 0x0ffffff
    }
  })
}

export function setComment (data) {
  return request.post('/comment/add', data)
}

export function getNewsList () {
  return request.get('/module/getData', {
    params: {
      name: 'news',
      org_code: 'aec'
    }
  })
}

export function getTabList () {
  return request.get('/module/getData', {
    params: {
      name: 'tab',
      org_code: 'aec'
    }
  })
}

export function getCaseList () {
  return request.get('/module/getData', {
    params: {
      name: 'case',
      org_code: 'aec'
    }
  })
}

export function getProductList () {
  return request.get('/module/getData', {
    params: {
      name: 'product',
      org_code: 'aec'
    }
  })
}

export function getSolutionList () {
  return request.get('/module/getData', {
    params: {
      name: 'solutionDynamic',
      org_code: 'aec'
    }
  })
}

export function getHelpList () {
  return request.get('/module/getData', {
    params: {
      name: 'help',
      org_code: 'aec'
    }
  })
}